
import userModel from "@/models/user-model";
import bannerModel from "@/models/banner-model";
import highlightModel from "@/models/highlight-model";
import casesModel from "@/models/cases-model";
import articleModel from "@/models/article-model";
import priceModel from "@/models/price-model";
import privacyModel from "@/models/privacy-model";

export default {
    userModel,
    bannerModel,
    highlightModel,
    casesModel,
    articleModel,
    priceModel,
    privacyModel
}


// WEBPACK FOOTER //
// ./src/models/http.js